'use strict';

import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import ButtonToolbar from "react-bootstrap/ButtonToolbar";
import ScheduleBuilderOptionModal from "./ScheduleBuilderOptionModal";
import pinnedSchedulesStore from './PinnedSchedulesStore';
import classnames from "classnames";
import appStore from "@uw-it-sis/lib-react/lib/AppStore";
import ScheduleBuilderOptionStore from "./ScheduleBuilderOptionStore";
import SimpleState from "@uw-it-sis/lib-react/lib/SimpleState";
import {MetricLabels} from "@uw-it-sis/lib-react-myplan/lib/Constants";

/**
 * Builds a component for each schedule option generated by SB. Contains data and action to display
 * schedule on calendar, modal for schedule details, and action to pin this schedule for later.
 */
class ScheduleBuilderOption extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.store = new ScheduleBuilderOptionStore();

        this.state = {
            showDetails: false,
        }

        // binding required on methods that are passed as properties
        this.hideDetails = this.hideDetails.bind(this);
        this.analyticsStore = appStore.getAnalyticsStore();
    }

    componentDidMount() {
        this.store.mount(this.props.schedule, this.props.resultIndex, this.props.initialDate, this.props.defaultShow);
    }

    componentWillUnmount() {
        this.store.unmount();
    }

    // Show the schedule details in modal
    showDetails(e, isPinned) {
        e.stopPropagation();
        let context = isPinned ? "SB-selection-pinned" : "SB-selection-option";
        const labels = this.analyticsStore.label(MetricLabels.appContextName, context).get();
        this.analyticsStore.addEvent("SB-open-details",labels, {});
        this.setState({showDetails: true});
    }

    // Close the schedule details modal
    hideDetails() {
        this.setState({showDetails: false});
    }

    highlightOption(e) {
        let card = e.target.closest(".card.scheduleBuilder-option");

        switch (e.type) {
            case "mouseover":
                card.classList.add("scheduleBuilder-option--hover");
                break;
            case "mouseout":
                card.classList.remove("scheduleBuilder-option--hover");
                break;
        }
    }

    // Action to show/hide schedule within calendar grid
    toggleSchedule() {
        this.store.toggleShowSchedule();
    }

    // Action to pin/unpin the schedule for later
    pinAction(e, pinnedScheduleId) {
        e.stopPropagation();
        this.store.togglePinned();
    }

    displayComponent() {
        let isPinned = this.store.displayState.pinned;
        let isShown = this.store.displayState.shown;

        let pinnedScheduleData = {};
        let description = `Option ${this.props.resultIndex}`;
        if (isPinned) {
            pinnedScheduleData = pinnedSchedulesStore.getSchedulePinnedData(this.props.schedule.activityHash);
            description = `Pinned ${pinnedScheduleData.number}`;
        }

        let pinAction =
            <Button variant="secondary"
                    size="sm"
                    className="btn-secondary-gray flex-md-fill"
                    title={`${isPinned ? 'Unpin':'Pin'} ${description}`}
                    disabled={appStore.isAdviser()}
                    onClick={(e) => this.pinAction(e, (isPinned ? pinnedScheduleData.id : null))}>
                <small>{isPinned ? 'Unpin':'Pin'}</small>
            </Button>;

        return (
            <>
                <Card className={classnames(
                    "scheduleBuilder-option",
                    {"scheduleBuilder-option--active": isShown},
                    {"scheduleBuilder-option--is-pinned": isPinned},
                    this.store.displayState.cssClasses.join(" ")
                )}>
                    <Card.Body className="p-0">
                        <Card.Title className="border-0 p-3 mb-0 w-100 bg-transparent text-start h4"
                                    as="button"
                                    role="button"
                                    type="button"
                                    aria-pressed={isShown}
                                    onMouseOver={this.highlightOption}
                                    onMouseOut={this.highlightOption}
                                    onClick={() => this.toggleSchedule()}>{description}</Card.Title>
                        <ButtonToolbar className="btn-toolbar-sm px-3 pb-3 mt-1 btn-toolbar-vertical-md flex-md-nowrap">
                            <Button variant="secondary"
                                    size="sm"
                                    className="btn-secondary-gray flex-md-fill text-nowrap"
                                    title={`View ${description} Details`}
                                    onClick={(e) => this.showDetails(e, isPinned)}>
                                <small className="d-inline"><span className="d-none d-sm-inline d-md-none d-xl-inline">View </span>Details</small>
                            </Button>
                            {pinAction}
                        </ButtonToolbar>
                    </Card.Body>
                </Card>
                <ScheduleBuilderOptionModal
                    schedule={this.props.schedule}
                    title={isPinned ? `Pinned Schedule ${pinnedScheduleData.number}`: `Schedule ${description}`}
                    show={this.state.showDetails}
                    onHide={this.hideDetails}
                    regDate={this.props.regDate}
                    planData={this.props.planData}/>
            </>
        );
    }

    render() {
        return <SimpleState state={this.store.state} doneComponentBuilder={() => this.displayComponent()}/>
    }
}

ScheduleBuilderOption.propTypes = {
    schedule: PropTypes.object.isRequired,
    initialDate: PropTypes.string.isRequired,
    defaultShow: PropTypes.bool.isRequired,
    resultIndex: PropTypes.number.isRequired,
    regDate: PropTypes.string.isRequired,
    planData: PropTypes.array.isRequired
}
ScheduleBuilderOption.defaultProps = {
    planData: []
}
export default ScheduleBuilderOption;